module.exports = __webpack_public_path__ + "img/mx.000a4ef7.png";